import axiosInstance from '../axiosInstance';

/**
 * Thin API wrapper for all livestream endpoints.
 */

export const getLiveStreams = (page = 1, search = '', limit = 12) =>
  axiosInstance.get('/livestreams', { params: { page, search, limit } });

export const getLiveStreamByUsername = (username) =>
  axiosInstance.get(`/livestreams/by-username/${username}`);

export const getLiveStream = (id) =>
  axiosInstance.get(`/livestreams/${id}`);

/**
 * Creator: create a new stream and get GetStream credentials + RTMP keys.
 * @param {FormData} formData — title, description, visibility, stream_mode, thumbnail (optional)
 */
export const createStream = (formData) =>
  axiosInstance.post('/livestreams', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const goLive = (liveStreamId) =>
  axiosInstance.post(`/livestreams/${liveStreamId}/go-live`);

export const endStream = (liveStreamId) =>
  axiosInstance.post(`/livestreams/${liveStreamId}/end`);

/**
 * Viewer: get a GetStream JWT token for the stream (checks visibility access).
 */
export const getViewerToken = (liveStreamId) =>
  axiosInstance.get(`/livestreams/${liveStreamId}/viewer-token`);

export const updateViewerCount = (liveStreamId, count) =>
  axiosInstance.post(`/livestreams/${liveStreamId}/viewer-count`, { count });

export const getMyStreams = (page = 1) =>
  axiosInstance.get('/my/livestreams', { params: { page } });

/**
 * Send a tip during a livestream.
 */
export const sendLivestreamTip = ({ creatorId, liveStreamId, amount, message, gateway, paymentMethodId, returnUrl }) =>
  axiosInstance.post('/livestreams/tip', {
    creator_id: creatorId,
    live_stream_id: liveStreamId,
    amount,
    message,
    gateway,
    payment_method_id: paymentMethodId || undefined,
    return_url: returnUrl || undefined,
  });

/**
 * Get available gifts for a stream (platform-wide + creator-specific).
 */
export const getGifts = (creatorId) =>
  axiosInstance.get('/gifts', { params: { creator_id: creatorId } });

/**
 * Creator: manage their custom gifts.
 */
export const getMyGifts = () => axiosInstance.get('/my/gifts');

export const createGift = (formData) =>
  axiosInstance.post('/my/gifts', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateGift = (id, formData) =>
  axiosInstance.post(`/my/gifts/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    params: { _method: 'PUT' },
  });

export const deleteGift = (id) => axiosInstance.delete(`/my/gifts/${id}`);

/**
 * Get stream history (chat messages + top gifters) for catch-up on join.
 */
export const getStreamHistory = (liveStreamId, beforeId = null) =>
  axiosInstance.get(`/livestreams/${liveStreamId}/history`, {
    params: beforeId ? { before_id: beforeId } : undefined,
  });

/**
 * Persist a chat message to the database.
 */
export const sendChatMessage = (liveStreamId, message) =>
  axiosInstance.post(`/livestreams/${liveStreamId}/chat`, { message });

/**
 * Purchase access to a paid livestream.
 */
export const purchaseAccess = (liveStreamId, { gateway, paymentMethodId, returnUrl } = {}) =>
  axiosInstance.post(`/livestreams/${liveStreamId}/purchase-access`, {
    gateway,
    payment_method_id: paymentMethodId || undefined,
    return_url: returnUrl || undefined,
  });
